export interface SupportedLanguage {
  culture: string;
  language: string;
  flag: string;
}

export enum Cultures {
  English = 'en-US',
  German = 'de-DE',
  Italian = 'it-IT',
  French = 'fr-FR',
}

export const countryCodeToFlag = (countryCode: string) => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => {
      const base = 0x1f1e6; // Base code point for regional indicators
      return base + char.charCodeAt(0) - 65;
    });

  return String.fromCodePoint(...codePoints);
};

export const supportedLanguages = new Map<number, SupportedLanguage>([
  [0, { culture: Cultures.English, language: 'English', flag: '🇺🇸' }],
  [1, { culture: Cultures.German, language: 'Deutsch', flag: '🇩🇪' }],
  [2, { culture: Cultures.Italian, language: 'Italiano', flag: '🇮🇹' }],
  [3, { culture: Cultures.French, language: 'Français', flag: '🇫🇷' }],
]);
